import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesTypesEvent = {
  description: '',
  code: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const EventPageInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesTypesEvent}>
      <Outlet />
    </FilterTableProvider>
  );
};

EventPageInitializer.displayName = 'Event home apage initializer component';

export default EventPageInitializer;
